<kl-grid
  [columns]="[
    { header: 'code' | translate, binding: 'code', width: '*', visible: true },
    {
      header: 'description' | translate,
      binding: 'description',
      width: '*',
      visible: true
    },
    {
      header: 'city' | translate,
      binding: 'city_name',
      width: '*',
      visible: true
    }
  ]"
  definition="Bankalar"
  [filterable]="true"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [dblSelect]="dblSelect"
  [filterSelectItems]="filterSelectItems"
  [service]="{
    service: 'taxarea',
    name: 'tax_houses',
    form: '',
    showButton: false,
    showDropDownButton: false
  }"
  [parentModuleName]="'APPLICATION_PARAMS'"
  [moduleName]="'TAXAREA_LIST'"
  [gridName]="'grdTaxareaList'"
>
</kl-grid>
